export default {
  tab: {
    Result: 'RESULT',
    Performance: 'PERFORMANCE',
    Financial: 'FINANCIAL',
    Technical: 'TECHNICAL',
  },

  button: {
    TOP_SCREEN: 'TOP SCREENS',
    MY_SCREEN: 'MY SCREENS',
    APPLY: 'APPLY',
    SAVE: 'SAVE',
    result: 'Screener Results ',
    CREATE: 'CREATE',
    DELETE: 'DELETE',
    CANCEL: 'CANCEL',
    export: 'EXPORT',
  },

  financialHeader: {
    TICKER: 'TICKER',
    PRICE: 'PRICE',
    PERCENT_PRICE_CHANGE: '% 1D CHANGE',
    ISA3: 'REVENUE<br>(TTM)',
    ISA20: 'NET PROFIT<br>(TTM)',
    RTD14: 'EPS<br>(TTM)',
    RTD7: 'BVPS (VND)',
    RTD21: 'P/E',
    RTD25: 'P/B',
    NET_PROFIT_GROWTH: 'Net Profit GROWTH (TTM)',
    EBIT_MARGIN: 'EBIT MARGIN (TTM)',
  },
  resultHeader: {
    TICKER: 'TICKER',
    SECTOR: 'SECTOR',
    RTD21: 'P/E<br>(TTM)',
    RTD11: 'MARKET CAP',
    RTD36: 'DIVIDEND YIELD (%)',
    RTD20: 'DIVIDEND YIELD (%)',
    AVERAGE_VOLUME_3MONTH: 'AVERAGE VOLUME 3M',
    CLOSE_PRICE: 'PRICE',
    OVER_SMA50: 'OVER SMA50',
    ORGANIZATION_OWNERSHIP: '% ORGANIZATION OWNERSHIP',
    AVERAGE_VALUE_1MONTH: 'AVERAGE VALUE 1M',
    RTD14: 'EPS<br>(TTM)',
    RTD25: 'P/B',
    RTD19: 'BETA',
    RTD55: 'EPS<br>(TTM) GROWTH YOY',
    RTQ12: 'ROE',
    RTQ160: 'SALES GROWTH IN 3 YEARS',
    RSI: 'RSI',
    RQD25: 'P/B<br>(MRQ)',
    RTD52: 'EPS growth<br>(TTM)',
    RYD52: 'EPS growth YoY',
    RYQ160: 'Sales growth in 3 year',
    RYQ166: 'Avg. Profit growth in 3 year',
    RYQ176: 'Owner Equity growth in 3 year',
    FREE_FLOAT_RATE: '% FREE FLOAT',
    GROWTH: 'GROWTH',
    MOMENTUM: 'MOMENTUM',
    VALUE: 'VALUE',
    VGM: 'VGM',
    ICBRANK: 'FIINTRADE RANK',
    INDEXRANK: 'INDEX RANK',
    CAPITAL_STRUCTURE: 'CAPITAL STRUCTURE',
    CFO: 'CFO',
    DEBT: 'DEBT',
    EQUITY_INSSURANCE: 'EQUITY INSSURANCE',
    FINANCIAL_PLAN: 'FINANCIAL PLAN',
    FINANCIAL_STRENGTH: 'FINANCIAL STRENGTH',
    GROSSMARGIN: 'GROSS MARGIN',
    PROFIT_GROWTH: 'PROFIT GROWTH',
    REVENUE_GROWTH: 'REVENUE GROWTH',
    ROE: 'ROE',
    ROA: 'ROA',
    RTD26: 'P/S<br>(TTM)',
    RTD28: 'PRICE TO CASH FLOW<br>(TTM)',
    RTD40: 'PRICE TO FREE CASH FLOW<br>(TTM)',
    RTD27: 'PRICE TO TANGIBLE BOOK<br>(TTM)',
    RTQ166: 'AVG.PROFIT GROWTH 3 YEARS',
    Rtq176: 'CAPITAL SPENDING GROWTH IN 3 YEARS',
    TOTALMATCHVOLUME: 'VOLUME',
    AVERAGEVOLUME2WEEK: 'AVERAGE VOL. 10D',
    PERCENTPRICECHANGE1DAY: '% DAILY CHANGE',
    PERCENTPRICECHANGE1WEEK: '% WEEKLY CHANGE',
    PERCENTPRICECHANGE1MONTH: '% MONTHLY CHANGE',
    PERCENTPRICECHANGE3MONTH: '% 3 MONTHS CHANGE',
    PERCENTPRICECHANGE6MONTH: '% 6 MONTHS CHANGE',
    PERCENTPRICECHANGE52WEEK: '% 52 WEEKS CHANGE',
    PERCENTPRICECHANGEYTD: '% YTD CHANGE',
    SMA20: 'MA(20)',
    SMA50: 'MA(50)',
    SMA100: 'MA(100)',
    AVERAGEVOLUME1WEEK: 'AVERAGE VOL. 5D',
    AVERAGEVOLUME1MONTH: 'AVERAGE VOL. 20D',
    REVTTM: 'REV (BN)<br>TTM',
    ISA20TTM: 'NET PROFIT<br>(TTM)',
    RTQ2: 'QUICK RATIO<br>(TTM)',
    RTQ3: 'CURRENT RATIO<br>(TTM)',
    RTQ4: 'LONG TERM DEBT TO EQUITY<br>(TTM)',
    RTQ6: 'TOTAL DEBT TO EQUITY<br>(TTM)',
    REVY: 'REVENUE<br>(LAST YEAR)',
    ISA20Y: 'NET PROFIT<br>(LAST YEAR)',
    RYQ25: 'GROSS MARGIN<br>(LAST YEAR)',
    RYQ29: 'NET PROFIT MARGIN<br>(LAST YEAR)',
    RYQ2: 'QUICK RATIO<br>(LAST YEAR)',
    RYQ3: 'CURRENT RATIO<br>(LAST YEAR)',
    RYQ4: 'LONG TERM DEBT TO EQUITY<br>(LAST YEAR)',
    RYQ6: 'TOTAL DEBT TO EQUITY<br>(LAST YEAR)',
    RTD43: 'DIVIDEND',
    RTD36AVG: 'DIVIDEND YIELD 3 YEARS AVG (%)',
    RTD20AVG: 'DIVIDEND YIELD 3 YEARS AVG (%)',
    RTD51: 'PAYOUT RATIO (%)',
    MA9: 'MA9',
    MA20: 'MA20',
    MA50: 'MA50',
    MA75: 'MA75',
    MA100: 'MA100',
    MA200: 'MA200',
    ADX: 'ADX',
    CCI: 'CCI',
    ROC: 'ROC',
    STOCHASTIC: 'STOCH',
    WILLIAMS: 'WILLIAMS',
    MFI: 'MFI',
    TOTALMATCHVALUE: 'Value',
    AVERAGEVALUE1WEEK: 'Average Val. 5D',
    AVERAGEVALUE2WEEK: 'Average Val. 10D',
    AVERAGEVALUE3MONTH: 'Average Val. 3M',
    RTQ78: 'Revenue Growth (YoY)',
    RTQ83: 'Net Profit Growth (YoY)',
    REV: 'Revenue <br> (latest quarter)',
    PRF: 'Net Profit <br> (latest quarter)',
    REVGROWTH: 'Revenue Growth <br> (latest quarter) (YoY)',
    PRFGROWTH: 'Net Profit Growth <br> (latest quarter) (YoY)',
    RTQ25: 'GROSS Profit MARGIN<br>(TTM)',
    RTQ29: 'NET PROFIT MARGIN<br>(TTM)',
    RTQ27: 'EBIT Margin <br> (TTM)',
    RQQ27: 'EBIT Margin <br> (Quarter)',
    RQQ29: 'Net Profit Margin <br> (Quarter)',
    RQQ25: 'Gross Profit Margin <br> (Quarter)',
    F_SCORE: 'F-Score <br> (TTM)',
    CANSLIM: 'Canslim <br> (TTM)',
    RTQ1: 'Cash Ratio <br> (TTM)',
    RTQ77: 'nterest Coverage Ratio <br> (TTM)',
    ForeignerRoom: 'Foreign Room',
    ForeignerPercentage: 'Foreign Ownership',
    CorpOwnership: '% Organization Ownership',
    RTQ79: 'Gross Profit Growth (YoY)',
    RTQ7: 'Total Debt to Total Asset (TTM)',
    RQQ6: 'Total Debt to Total Equity (Quarter)',
    RQQ23: 'ROIC (Quarter)',
  },
  screenerMessage: {
    confirmDelete: 'Delete this screener?',
    warningTitle: 'Unable to save screen!',
    addCriteria: 'ADD CRITERIA',
    selectedCriteria: 'SELECTED CRITERIA',
    errorEmptyParam:
      'To save a screen, you need to choose at least one criteria.',
    errorEmptyname: 'Invalid name',
    placeHolder: 'Name your screen',
    warnMaxParam: 'Criteria Limit',
    errorMaxParam: 'You cannot choose more than 10 criteria. Please try again.',
  },
  allExchanges: 'All Exchanges',
  allSectors: 'All Sectors',
};
